import { render } from "./CatalogMobilePhoneInput.vue?vue&type=template&id=55b03fa6"
import script from "./CatalogMobilePhoneInput.vue?vue&type=script&lang=js"
export * from "./CatalogMobilePhoneInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\AgentModule\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__